@file:Suppress("REDUNDANT_VISIBILITY_MODIFIER")

package com.bikompanion.`data`

import kotlin.Boolean
import kotlin.String
import kotlin.Suppress

internal object BuildKonfig {
  public val IS_DEBUG: Boolean = false

  public val VERSION_NAME: String = "1.0.0"

  public val CITY_BIKES_DEBUG_API_KEY: String = ""

  public val FIREBASE_API_KEY: String = "AIzaSyA9yNJi8RCOa9rZ_dsj2D8iIst90C7duHU"

  public val FIREBASE_APP_ID: String = "1:259395888662:web:6c42339592d1f6b1c8b737"

  public val FIREBASE_PROJECT_ID: String = "bikompanion"

  public val FIREBASE_AUTH_DOMAIN: String = "bikompanion.firebaseapp.com"

  public val FIREBASE_SENDER_ID: String = "259395888662"

  public val FIREBASE_DB_URL: String =
      "https://bikompanion-default-rtdb.europe-west1.firebasedatabase.app"

  public val FIREBASE_EMULATOR_HOST: String = ""
}
